// @flow

import type { LinksType } from '../../../NewWizard.types'

export function getOptions(links: LinksType): Array<Object> {
  return links.map(link => ({ value: link.block, label: link.name }))
}
